import React from 'react';
import { Flame, ThermometerSun, Wind } from 'lucide-react';

const BASE_URL = `${import.meta.env.BASE_URL}`;
export const SITE_URL = 'https://www.mainlandfireplaces.com';

export const SITE_DATA = {
  brandName: 'Mainland Fireplaces & Grills',
  brandLogo: `${BASE_URL}images/logo/logo.png`,
  phone: '(604) 533-2198',
  email: 'info@mainlandfireplaces.com',
  location: 'Langley, BC',
  mapLink: 'https://maps.app.goo.gl/wbAuXyDAvyfT9A6B7',
  categories: [
    {
      id: 'gas',
      title: 'Gas',
      subtitle: 'Efficient Warmth',
      description: 'Efficient, powerful, and timeless. Delivering real flames and consistent warmth at the push of a button.',
      image: `${BASE_URL}images/heros/gas.avif`,
    },
    {
      id: 'electric',
      title: 'Electric',
      subtitle: 'Sleek & Safe',
      description: 'Perfect for condos and modern interiors. Enjoy instant ambiance with zero mess. Sleek, safe, and easy to install.',
      image: `${BASE_URL}images/heros/electric.avif`,
    },
    {
      id: 'luxury',
      title: 'Luxury Gas',
      subtitle: 'Custom Built',
      description: 'Elevate your space with high-end, custom-built gas fireplaces. Designed to impress and crafted to last.',
      image: `${BASE_URL}images/heros/luxury_gas.avif`,
    },
    {
      id: 'outdoor-kitchen',
      title: 'Outdoor Kitchen',
      subtitle: 'Alfa Oven',
      description: 'Take the indoors out with premium grilling stations. Featuring Napoleon® BBQs and ALFA Pizza Ovens.',
      image: `${BASE_URL}images/heros/outdoor_kitchen.webp`,
    },
    {
      id: 'outdoor-fire',
      title: 'Outdoor Fire Features',
      subtitle: 'Atmosphere',
      description: 'Bring warmth and atmosphere to your backyard. From fire tables to custom fire features.',
      image: `${BASE_URL}images/heros/outdoor_fire.avif`,
    },
  ],
  brands: [
    {
      name: 'Napoleon',
      logo: `${BASE_URL}images/brands/napoleon.png`
    },
    {
      name: 'The Outdoor Greatroom Company',
      logo: `${BASE_URL}images/brands/OGR.png`
    },
    {
      name: 'Lyonstone Design',
      logo: `${BASE_URL}images/brands/lyonstone.png`
    },
    {
      name: 'Xtrordinair',
      logo: `${BASE_URL}images/brands/xtrordinair.png`
    },
    {
      name: 'Amantii',
      logo: `${BASE_URL}images/brands/amantii.png`
    },
    {
      name: 'Urbana',
      logo: `${BASE_URL}images/brands/urbana.png`
    },
    {
      name: 'Alfa',
      logo: `${BASE_URL}images/brands/alfa.webp`
    },
    {
      name: 'Bromic',
      logo: `${BASE_URL}images/brands/bromic.png`
    },
    {
      name: 'Simplifire',
      logo: `${BASE_URL}images/brands/simplifire.png`
    },
    {
      name: 'Escea',
      logo: `${BASE_URL}images/brands/escea.png`
    },
    {
      name: 'Heat & Glo',
      logo: `${BASE_URL}images/brands/heat_glo.png`
    },
    {
      name: 'Marquis',
      logo: `${BASE_URL}images/brands/marquis.png`
    },
    {
      name: 'Modern Flames',
      logo: `${BASE_URL}images/brands/modern_flames.png`
    },
    {
      name: 'DaVinci Fireplaces',
      logo: `${BASE_URL}images/brands/davinci.png`
    },
    {
      name: 'Tempest',
      logo: `${BASE_URL}images/brands/tempest.png`
    },
    {
      name: 'Dimplex',
      logo: `${BASE_URL}images/brands/dimplex.png`
    },
    {
      name: 'Montigo',
      logo: `${BASE_URL}images/brands/montigo.png`
    },
    {
      name: 'Town & Country',
      logo: `${BASE_URL}images/brands/town_country.png`
    },
    {
      name: 'Fire Garden',
      logo: `${BASE_URL}images/brands/fire_garden.png`
    },
    {
      name: 'Heatilator',
      logo: `${BASE_URL}images/brands/heatilator.png`
    },
    {
      name: 'Sunpak',
      logo: `${BASE_URL}images/brands/sunpak.png`
    },
    {
      name: 'Barbara Jean',
      logo: `${BASE_URL}images/brands/barbara_jean.png`
    }
  ],
  outdoorFeatures: [
    {
      title: 'Fire Tables',
      desc: 'The perfect centerpiece for conversation. Available in concrete, stone, and modern metal finishes.',
      icon: <Flame className='w-6 h-6' />,
      image: `${BASE_URL}images/products/fire_tables.avif`,
    },
    {
      title: 'Patio Heaters',
      desc: 'Extend your patio season with high-efficiency radiant heaters from Bromic and Infratech.',
      icon: <ThermometerSun className='w-6 h-6' />,
      image: `${BASE_URL}images/products/patio_heaters.avif`,
    },
    {
      title: 'Fire Bowls',
      desc: 'Architectural statements that bring drama and warmth to pool decks and landscapes.',
      icon: <Wind className='w-6 h-6' />,
      image: `${BASE_URL}images/products/fire_bowls.avif`,
    },
  ],
  testimonials: [
    {
      name: 'MSG Developments',
      role: 'Custom Home Builder',
      text: "We have been purchasing fireplaces from Mainland fireplaces for quite some time now for all our custom home projects, and the experience has been outstanding from start to finish. The selection of fireplaces is extensive, the staff is incredibly knowledgeable, helping our clients choose the perfect model for any space. Installation is seamless, with a professional team ensuring everything is set up safely and efficiently. If you're looking for a reliable fireplace supplier with excellent products and customer service, we highly recommend Mainland Fireplaces.",
    },
    {
      name: 'Steven Me',
      role: 'Homeowner',
      text: "Mainland Fireplaces did an amazing job at transforming our living room with a beautiful wall build-out to hold a large fireplace. They completed the look with a cement finish which looks fantastic. Very modern. I would highly recommend them.",
    },
    {
      name: 'Melissa Fraser',
      role: 'Homeowner',
      text: "Mainland installed our fireplaces and has helped us with maintenance since. As someone who knows nothing about fireplaces they have helped answer questions on several occasions and provided great customer service since the installation. Absolutely recommend them for sales and service.",
    },
  ]
};